import styled from "styled-components";
import { addIcon, hoverStyle, focusStyle, subText, tertiarySmall, ellipsis, activeStyle } from "@mixins";
export var SortableColumn = styled.button.withConfig({
  displayName: "organizationsliststyles__SortableColumn",
  componentId: "sc-d8kma6-0"
})(["&:after{position:absolute;right:5px;bottom:5px;line-height:2.4rem;", "}", ""], function (_ref) {
  var theme = _ref.theme,
    icon = _ref.icon;
  return addIcon(theme, icon);
}, function (_ref2) {
  var theme = _ref2.theme,
    active = _ref2.active,
    disabled = _ref2.disabled;
  return "\n    padding: 0 35px 0 5px;\n    background: none;\n    position: relative;\n    text-align: left;\n    width: 100%;\n    height: 34px;\n    transition: all .3s;\n\n    &:hover{ ".concat(!disabled && hoverStyle(theme) || "", " }\n    &:focus{ ").concat(focusStyle(theme), " }\n    ").concat(active ? activeStyle(theme) : "", "\n  ");
});
export var Th = styled.th.withConfig({
  displayName: "organizationsliststyles__Th",
  componentId: "sc-d8kma6-1"
})(["", ""], function (_ref3) {
  var theme = _ref3.theme;
  return "\n    ".concat(tertiarySmall(theme), "\n    text-align: left;\n    padding-left: 5px;\n\n    &:first-child{ width: 50px; }\n    &:last-child{ width: 90px; }\n  ");
});
export var Td = styled.td.withConfig({
  displayName: "organizationsliststyles__Td",
  componentId: "sc-d8kma6-2"
})(["padding:0 5px;max-width:0;&:last-child{padding:0;}"]);
export var Tr = styled.tr.withConfig({
  displayName: "organizationsliststyles__Tr",
  componentId: "sc-d8kma6-3"
})(["", ""], function (_ref4) {
  var theme = _ref4.theme;
  return "\n    height: 34px;\n\n    &:not(:first-child){ box-shadow: 0 -1px 0 0px ".concat(theme.colors.G4, "1a; }\n    &:last-child{ box-shadow: 0 -1px 0 0px ").concat(theme.colors.G4, "1a, 0 1px 0 0 ").concat(theme.colors.G4, "1a; }\n    ");
});
export var RemoveUnit = styled.button.withConfig({
  displayName: "organizationsliststyles__RemoveUnit",
  componentId: "sc-d8kma6-4"
})(["&:before{color:", ";", "}", ""], function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.G1;
}, function (_ref6) {
  var theme = _ref6.theme,
    disableUnitsInteraction = _ref6.disableUnitsInteraction;
  return !disableUnitsInteraction ? addIcon(theme, "cross_xs", "auto") : "";
}, function (_ref7) {
  var theme = _ref7.theme,
    color = _ref7.color;
  return "\n    border: none;\n    outline: none;\n    width: 26px;\n    height: 26px;\n    border-radius: 50%;\n    margin: auto auto auto 5px;\n    background: ".concat(color, ";\n    transition: all .3s;\n\n    &:focus { ").concat(focusStyle(theme), " }\n    &:hover {\n      ").concat(hoverStyle(theme), "\n      &:before { color: ").concat(theme.colors.P1, "; }\n    }\n    &.hidden-styles{\n      position: relative;\n      opacity: 1;\n      z-index: auto;\n      width: 26px;\n      height: 26px;\n      &:before{\n        content: '';\n      }\n    }\n    ");
});
export var DrillButton = styled.button.withConfig({
  displayName: "organizationsliststyles__DrillButton",
  componentId: "sc-d8kma6-5"
})(["&:after{position:absolute;right:15px;", "}", ""], function (_ref8) {
  var theme = _ref8.theme,
    disabled = _ref8.disabled;
  return !disabled ? addIcon(theme, "expandRight_xs") : "";
}, function (_ref9) {
  var theme = _ref9.theme,
    disabled = _ref9.disabled;
  return "\n    ".concat(subText(theme), "\n    ").concat(ellipsis, "\n    color: ").concat(theme.colors.G4, ";\n    position: relative;\n    width: 100%;\n    height: 33px;\n    padding-right: 30px;\n    text-align: left;\n    background: none;\n    transition: all .3s;\n\n    ").concat(!disabled ? "\n      &:focus { ".concat(focusStyle(theme), " }\n      &:hover { ").concat(hoverStyle(theme), " }\n    ") : "");
});
export var Value = styled.p.withConfig({
  displayName: "organizationsliststyles__Value",
  componentId: "sc-d8kma6-6"
})(["", ""], function (_ref10) {
  var theme = _ref10.theme,
    values = _ref10.values;
  return "\n    ".concat(values === 2 ? tertiarySmall(theme) : subText(theme), "\n    margin: auto;\n    width: 100%;\n    height: ").concat(values === 2 ? "50%" : "100%", ";\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    &:nth-child(2){\n      font-family: ").concat(theme.fonts.robotoRegular, ";\n      background: ").concat(theme.colors.P3, ";\n      color: ").concat(theme.colors.G1, ";\n      margin: 0;\n      padding: 1px 0;\n    }");
});